import { render, staticRenderFns } from "./FacturaForm.vue?vue&type=template&id=0892d49a"
import script from "./FacturaForm.vue?vue&type=script&lang=js"
export * from "./FacturaForm.vue?vue&type=script&lang=js"
import style0 from "./FacturaForm.vue?vue&type=style&index=0&id=0892d49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports